export default function CadastrarFornecedor() {
    return (
        <div>
            <h1>Cadastrar Fornecedores</h1>
            <p>Esse componente ser usado para cadastro de fornecedores</p>
        </div>
    )
}